"use strict";

const v2PdpJs = {
  selectedAddOns: new Map(),
  originalSlides: null,
  originalThumbSlides: null,
  shields: false,
  floatie: false,
  productData: null,
  debouncedUpdatePriceDisplay: null,
  // debouncedInitImageZoom: null,
  abTestEnabled: false,
  isShieldToggleChecked: false,

  init() {
    const jsonElement = document.getElementById("v2pdp-json");
    if (!jsonElement) return;

    try {
      this.productData = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error("Failed to parse product JSON:", error);
      return;
    }

    // Create debounced version of handleImageZoom for feature swiper
    /*  this.debouncedInitImageZoom = this.debounce(() => {
      if (typeof handleImageZoom === "function") {
        handleImageZoom(".v2pdp-feature-swiper");
      }
    }, 150); */

    const initialVariantId = this.getInitialVariantId();
    this.updateUrlWithVariantId(initialVariantId);

    const initialVariant = this.productData.variants.find(
      (v) => v.id.toString() === initialVariantId.toString()
    );

    if (initialVariant) {
      this.filterSlides(initialVariant);
      this.checkAndUpdateOOSStatus(initialVariant);
      this.updateLensSection(initialVariant);
    }

    this.handleV2PdpOptions();
    this.addOnToggleChangePrice();
    this.setupEventListeners();
    this.listenToShields();
    this.setupShieldToggle();
    this.setupFloatieToggle();
    this.setupRiserToggle();
    this.checkUrlForAddons();
    this.cleanupVariantOptions();

    this.isAbTestEnabled();
    this.handleRxOption();
  },

  updateLensSection(variant) {
    const photochromicLensSection = document.querySelector('.pwo-section');
    const bluemirrorLensSection = document.querySelector('.bmwo-section');
    const defaultLensSection = document.querySelector('.lens-compare-section');
    if (photochromicLensSection && variant.options.includes('Polarized Photochromic')) {
      photochromicLensSection?.classList.remove('hidden');
      bluemirrorLensSection?.classList.add('hidden');
      defaultLensSection?.classList.add('hidden');
    } else if (bluemirrorLensSection && variant.options.includes('Polarized Grey / Blue Mirror')) {
      photochromicLensSection?.classList.add('hidden');
      bluemirrorLensSection?.classList.remove('hidden');
      defaultLensSection?.classList.add('hidden');
    } else {
      photochromicLensSection?.classList.add('hidden');
      bluemirrorLensSection?.classList.add('hidden');
      defaultLensSection?.classList.remove('hidden');
    }
  },

  destroy() {
    // Clean up event listeners
    const addToCartButton = document.getElementById("v2pdp-availability");
    if (addToCartButton) {
      addToCartButton.removeEventListener(
        "click",
        this.handleV2AddToCart.bind(this)
      );
    }

    const btns = document.querySelectorAll(".ombraz-v2pdp__toggle-input");
    btns.forEach((btn) => {
      btn.removeEventListener("change", this.debouncedUpdatePriceDisplay);
    });

    const shieldToggle = document.querySelector(
      'input[data-product-type="is_shield"]'
    );
    if (shieldToggle) {
      shieldToggle.removeEventListener(
        "change",
        this.handleShieldToggle.bind(this)
      );
    }

    const floatieToggle = document.querySelector(
      'input[data-product-type="is_floatie"]'
    );
    if (floatieToggle) {
      floatieToggle.removeEventListener(
        "change",
        this.handleFloatieToggle.bind(this)
      );
    }

    // Clean up frame size sync listeners
    const frameSizeBtns = document.querySelectorAll(
      ".ombraz-v2pdp__product-options .size-option input[name='frame-size']"
    );

    frameSizeBtns.forEach((btn) => {
      btn.removeEventListener("change", this.handleFrameSizeChange);
    });
  },

  setupEventListeners() {
    const addToCartButton = document.getElementById("v2pdp-availability");

    if (addToCartButton) {
      addToCartButton.addEventListener(
        "click",
        this.handleV2AddToCart.bind(this)
      );
    }

    // Frame size sync setup
    const frameSizeBtns = document.querySelectorAll(
      ".ombraz-v2pdp__product-options .size-option input[name='frame-size']"
    );
    const dialogSizingBtns = document.querySelectorAll(
      ".size-info-dialog__content-sizing-toggle input[name='size']"
    );

    // Optimize event listeners to reduce complexity and improve performance
    const syncDialogWithPDP = (selectedValue) => {
      dialogSizingBtns.forEach((dialogBtn) => {
        if (dialogBtn.value.toLowerCase() === selectedValue.toLowerCase()) {
          dialogBtn.checked = true;
          dialogBtn.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    };

    const syncPDPWithDialog = (selectedSize) => {
      frameSizeBtns.forEach((btn) => {
        if (btn.value.toLowerCase() === selectedSize.toLowerCase()) {
          btn.checked = true;
          btn.dispatchEvent(new Event("change"));
        }
      });
    };

    // Use event delegation and optimize event handling
    if (frameSizeBtns.length && dialogSizingBtns.length) {
      document.addEventListener("change", (e) => {
        // Check if the event target is a frame size button
        if (
          e.target.matches(
            '.ombraz-v2pdp__product-options .size-option input[name="frame-size"]'
          )
        ) {
          const selectedValue = e.target.value.toLowerCase();
          syncDialogWithPDP(selectedValue);
        }

        // Check if the event target is in the sizing toggle
        if (
          e.target.matches(
            '.size-info-dialog__content-sizing-toggle input[name="size"]'
          )
        ) {
          const selectedSize = e.target.value;
          syncPDPWithDialog(selectedSize);

          // Show size toggles in product options
          const frameSizeFieldset = document.querySelector(
            "#original-version fieldset:last-child"
          );
          if (frameSizeFieldset) {
            frameSizeFieldset.classList.remove("hide-this");
          }

          // Close the dialog
          const sizingDialog = document.getElementById("size-info-dialog");
          if (sizingDialog) {
            sizingDialog.close();
          }
        }
      });
    }

    // Sync dialog size with PDP size when opening dialog
    const sizeInfoButton = document.getElementById("size-info-button");
    if (sizeInfoButton) {
      sizeInfoButton.addEventListener("click", () => {
        const sizingDialog = document.getElementById("size-info-dialog");

        if (!sizingDialog) {
          console.error("Size info dialog not found!");
          return;
        }

        // Get currently selected size from PDP
        const currentPdpSize = document.querySelector(
          "#original-version input[name='frame-size']:checked"
        )?.value;

        // Update dialog size radio to match PDP selection
        if (currentPdpSize) {
          const dialogSizeRadio = document.querySelector(
            `#size-info-dialog input[name="size"][value="${currentPdpSize}"]`
          );
          if (dialogSizeRadio) {
            dialogSizeRadio.checked = true;
          }
        }

        // Show the dialog
        sizingDialog.showModal();
      });
    }

    // Add close button functionality
    const closeSizeInfoButton = document.querySelector(
      ".size-info-dialog__close-button"
    );
    if (closeSizeInfoButton) {
      closeSizeInfoButton.addEventListener("click", () => {
        const sizingDialog = document.getElementById("size-info-dialog");
        if (sizingDialog) {
          sizingDialog.close();
        }
      });
    }

    // Close dialog when clicking outside
    const sizingDialog = document.getElementById("size-info-dialog");
    if (sizingDialog) {
      sizingDialog.addEventListener("click", (event) => {
        if (event.target === sizingDialog) {
          sizingDialog.close();
        }
      });
    }
  },

  isAbTestEnabled() {
    /**
     * Sets up the UI based on test type
     * Currently supports:
     * - E-test: Modified sizing UI with hidden VTO button
     * - Original: Default UI with all features
     */
    const setupTest = (testType) => {
      this.testType = testType;

      if (testType === "e-test") {
        this.setupETestUI();
      } else {
        this.setupOriginalUI();
      }
    };

    // Check initial page load state
    if (document.body.classList.contains("e-test")) {
      setupTest("e-test");
    } else {
      setupTest("original");
    }

    // Watch for class changes on body
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          if (document.body.classList.contains("e-test")) {
            setupTest("e-test");
          } else {
            setupTest("original");
          }
        }
      });
    });

    observer.observe(document.body, { attributes: true });
  },

  setupOriginalUI() {
    const elements = {
      originalVersion: document.getElementById("original-version"),
      abtestVersion: document.getElementById("abtest-version"),
      whatMySize: document.querySelector(".is-new-size-btn"),
      sizing: document.querySelector(".v2pdp__abtest-sizing-info"),
      frameSize: document.querySelector(
        "#original-version fieldset:last-child"
      ),
      vtoBtn: document.querySelector(".ombraz-v2pdp-vto"),
      modalVto: document.querySelector(".modal-vto-wrapper"),
      modalHr: document.querySelector(".ombraz-modal__content hr"),
    };

    // Show original elements
    elements.originalVersion?.classList.remove("hide-this");
    elements.whatMySize?.classList.remove("hide-this");
    elements.vtoBtn?.classList.remove("hide-this");
    elements.modalVto?.classList.remove("hide-this");
    elements.modalHr?.classList.remove("hide-this");
    elements.frameSize?.classList.remove("hide-this");

    // Hide test elements
    elements.abtestVersion?.classList.add("hide-this");
    elements.sizing?.classList.add("hide-this");

    this.updateAddOnTitle();
    this.handleV2PdpOptions();
    this.syncVariantWithUrl();
  },

  setupETestUI() {
    const elements = {
      originalVersion: document.getElementById("original-version"),
      abtestVersion: document.getElementById("abtest-version"),
      atcBtn: document.getElementById("v2pdp-availability"),
      oosBtn: document.querySelector(".oos-btn"),
      sizing: document.querySelector(".v2pdp__abtest-sizing-info"),
      vtoBtn: document.querySelector(".ombraz-v2pdp-vto"),
      whatMySize: document.querySelector(".is-new-size-btn"),
      modalVtoBtn: document.querySelector(".size-info-dialog__vto-btn-wrapper"),
      sizingToggle: document.querySelector(
        ".size-info-dialog__content-sizing-toggle"
      ),
    };

    // Show E-test elements
    elements.originalVersion?.classList.remove("hide-this");
    elements.sizing?.classList.remove("hide-this");
    elements.sizingToggle?.classList.remove("hide-this");

    // Hide unused elements
    elements.abtestVersion?.classList.add("hide-this");
    elements.whatMySize?.classList.add("hide-this");
    elements.vtoBtn?.classList.add("hide-this");
    elements.modalVtoBtn?.classList.add("hide-this");

    // Style updates
    elements.atcBtn.style.backgroundColor = "#9caf89";
    elements.oosBtn.style.backgroundColor = "#9caf89";

    this.handleV2PdpOptions();
    this.syncVariantWithUrl();
  },

  syncVariantWithUrl() {
    // Sync variant selection with URL parameter
    const variantId = new URL(window.location.href).searchParams.get("variant");
    if (variantId) {
      const variantRadio = document.querySelector(
        `#original-version input[value="${variantId}"]`
      );
      if (variantRadio) {
        variantRadio.checked = true;
        variantRadio.dispatchEvent(new Event("change"));
      }
    }
  },

  getInitialVariantId() {
    const checkedRadio = document.querySelector(
      ".ombraz-v2pdp__product-options input[type=radio]:checked"
    );

    if (checkedRadio) {
      const selectedValues = Array.from(
        document.querySelectorAll(
          ".ombraz-v2pdp__product-options input[type=radio]:checked"
        )
      ).map((radio) => radio.value);

      const matchedVariant = this.productData.variants.find((variant) =>
        variant.options.every((option, _) => selectedValues.includes(option))
      );

      return matchedVariant
        ? matchedVariant.id
        : this.productData.variants[0].id;
    }

    return this.productData.variants[0].id;
  },

  updateUrlWithVariantId(variantId, skipSlideUpdate = false) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());

    // Only update slides if skipSlideUpdate is false
    if (!skipSlideUpdate) {
      const variant = this.productData.variants.find(
        (v) => v.id.toString() === variantId.toString()
      );
      if (variant) {
        this.filterSlides(variant);
      }
    }
  },

  handleV2PdpOptions() {
    const productIdElem = document.getElementById("v2-pdp-id");
    const productPriceElem = document.getElementById("v2pdp-price");
    const addToCartButton = document.getElementById("v2pdp-availability");
    const oosButton = document.querySelector(".oos-btn");

    const selectedOptionElems = document.querySelectorAll(
      "#original-version .selected-option-value"
    );
    const optionRadios = document.querySelectorAll(
      "#original-version .ombraz-v2pdp__product-options input[type=radio]"
    );

    if (!optionRadios.length) return;

    const updateSelectedOptionHeader = (matchedVariant) => {
      selectedOptionElems.forEach((elem, index) => {
        elem.textContent = matchedVariant[`option${index + 1}`].replaceAll(' / ', ', ');
      });
    };

    const getMatchedVariant = () => {
      const selectedValues = Array.from(optionRadios)
        .filter((r) => r.checked)
        .map((r) => r.value);
      return this.productData.variants.find((variant) =>
        variant.options.every((option) => selectedValues.includes(option))
      );
    };

    const initialVariant = getMatchedVariant();
    if (initialVariant) updateSelectedOptionHeader(initialVariant);

    optionRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const checked = radio.checked;
        const matchedVariant = getMatchedVariant();

        if (!matchedVariant) return;

        // Only filter slides if the changed radio is not in the last fieldset
        if (
          !radio.closest(
            ".ombraz-v2pdp__product-options-wrapper fieldset:last-of-type"
          )
        ) {
          this.filterSlides(matchedVariant);
        }

        productIdElem.value = matchedVariant.id;
        this.updateUrlWithVariantId(matchedVariant.id);

        updateSelectedOptionHeader(matchedVariant);

        const basePrice = matchedVariant.price / 100;
        const compareAtPrice = matchedVariant.compare_at_price / 100;

        productPriceElem.dataset.basePrice = basePrice;
        productPriceElem.dataset.comparePrice = compareAtPrice;
        this.updatePriceDisplay(basePrice, compareAtPrice);
        this.checkAndUpdateOOSStatus(matchedVariant);
        this.updateLensSection(matchedVariant);

        if (matchedVariant.available && checked) {
          addToCartButton?.classList.remove("hide-this");
          oosButton?.classList.add("hide-this");
        } else {
          addToCartButton?.classList.add("hide-this");
          oosButton?.classList.remove("hide-this");
        }
      });
    });
  },

  /**
   * Maps the selected variant options to the alt text to use for the product image
   *
   * @param {string} option1 The selected option for the frame color
   * @param {string} option2 The selected option for the lens color
   * @returns {string} The alt text to use for the product image
   */
  mapVariantToAltText(option1, option2) {
    const productTitle = document.querySelector("h1")?.textContent?.toLowerCase().trim() || "";
    const frameColor = option1.toLowerCase();
    const lensOption = option2.toLowerCase();

    let altText = "";

    // Check for Limited Edition Dolomite Slate (Slate = LE for Dolomite)
    if (productTitle.includes("dolomite") && frameColor.includes("slate")) {
      altText = "dolomite_slate_brown";
      return altText;
    }

    // Photochromic lens
    if (lensOption.includes("photochromic")) {
      altText = "tortoise_photochromic";
      return altText;
    }

    const isNewBlueMirror = (product, lens) => {
      return (product.includes("classic") || product.includes("viale") || product.includes("teton") || product.includes("leggero")) && lens.includes("blue mirror");
    }

    if (productTitle.includes("azzurro") || isNewBlueMirror(productTitle, lensOption)){
      let adjustedLensOption = lensOption.replace("polarized", "").replace("non-", "").replace(/ /g, "").replace("/", "_");
      altText = productTitle + "-" + frameColor + "-" + adjustedLensOption;
      return altText;
    }

    if (frameColor.includes("matte brown")) {
      altText = "mattebrown_";
    } else if (frameColor.includes("black ice")) {
      altText = "black_ice_";
    } else {
      altText = frameColor.replace(" ", "_") + "_";
    }

    if (lensOption.includes("grey") || lensOption.includes("gray")) {
      altText += "grey";
    } else if (lensOption.includes("brown")) {
      altText += "brown";
    } else if (lensOption.includes("yellow")) {
      altText += "yellow";
    } else if (lensOption.includes("blue-blocking")) {
      altText += "blocker";
    } else if (lensOption.includes("silver mirror")) {
      altText += "silver_mirror";
    } else if (lensOption.includes("grey mirror")) {
      altText += "grey_mirror";
    } else if (lensOption.includes("blue mirror")) {
      altText += "blue_mirror";
    }

    if (frameColor === "radavist kelp" && lensOption === "yellow polarized") {
      altText = "dolomite_radavist";
    } else if (frameColor === "frost" && lensOption === "grey mirror") {
      altText = "frost_polarized_grey_mirror";
    }

    return altText;
  },

  checkAndUpdateOOSStatus(variant) {
    const addToCartButton = document.getElementById("v2pdp-availability");
    const oosButton = document.querySelector(".oos-btn");

    if (variant && !variant.available) {
      addToCartButton?.classList.add("hide-this");
      oosButton?.classList.remove("hide-this");
    } else {
      addToCartButton?.classList.remove("hide-this");
      oosButton?.classList.add("hide-this");
    }
  },

  async handleV2AddToCart(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const items = [];

    // Get variant ID from URL
    const variantId = new URL(window.location.href).searchParams.get("variant");
    if (!variantId) {
      console.error("No variant ID found in URL");
      return;
    }

    // Check for unavailable add-ons first
    const unavailableAddons = [];
    const addOnInputs = document.querySelectorAll(
      ".ombraz-v2pdp__toggle-input:checked"
    );

    addOnInputs.forEach((input) => {
      const isAvailable = input.dataset.available === "true";
      if (!isAvailable) {
        const toggleCard = input.closest(".ombraz-v2pdp__toggle-card");
        const addonTitle =
          toggleCard.querySelector("h3")?.textContent.trim() || "Add-on";
        unavailableAddons.push(addonTitle);
      }
    });

    // Show modal if there are unavailable items
    if (unavailableAddons.length > 0) {
      this.showUnavailableAddonsModal(unavailableAddons);
      return;
    }

    // Add main product
    items.push({
      id: variantId,
      quantity: 1,
    });

    // Add shields if selected and available
    if (this.shields && this.productData.shield_variant?.available) {
      items.push({
        id: this.productData.shield_variant.id,
        quantity: 1,
      });
    }

    // Add floatie if selected and available
    if (this.floatie && this.productData.floatie_variant?.available) {
      items.push({
        id: this.productData.floatie_variant.id,
        quantity: 1,
      });
    }

    // Add available add-ons
    const availableAddons = Array.from(addOnInputs)
      .filter((input) => input.dataset.available === "true")
      .map((input) => ({
        id: input.value,
        quantity: 1,
      }));

    items.push(...availableAddons);

    try {
      await OmbrazUtils.v2AddToCart(items, {
        button,
        updateSlideCart: true,
      });
    } catch (error) {
      console.error("Error adding items to cart:", error);
    }
  },

  addOnToggleChangePrice() {
    const btns = document.querySelectorAll(".ombraz-v2pdp__toggle-input");
    const price = document.getElementById("v2pdp-price");

    if (!btns.length) return;

    this.debouncedUpdatePriceDisplay = this.debounce(
      this.updatePriceDisplay.bind(this),
      100
    );

    btns.forEach((btn) => {
      // Skip if this is a riser toggle as it's handled separately
      if (btn.dataset.productType === "is_riser") return;

      btn.addEventListener("change", (event) => {
        console.log("addontoggle");
        const checked = event.target.checked;
        const addOnPrice = Number.parseFloat(btn.dataset.toggleProductPrice.replace(/,/g, ''));

        if (checked) {
          this.selectedAddOns.set(btn.value, addOnPrice);
        } else {
          this.selectedAddOns.delete(btn.value);
        }

        const basePrice = Number.parseFloat(price.dataset.basePrice.replace(/,/g, ''));
        this.debouncedUpdatePriceDisplay(basePrice);
      });
    });
  },

  insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, insertPosition = 2) {
    if (!this.floatie) return;

    const floatieSlide = this.originalSlides.find((slide) => {
      const img = slide.querySelector("img");
      return img?.alt.toLowerCase().includes("floatie");
    });

    const floatieThumbSlide = this.originalThumbSlides.find((slide) => {
      const img = slide.querySelector("img");
      return img?.alt.toLowerCase().includes("floatie");
    });

    if (floatieSlide && floatieThumbSlide) {
      const floatieSlideClone = floatieSlide.cloneNode(true);
      const floatieThumbSlideClone = floatieThumbSlide.cloneNode(true);

      slidesToAppend.splice(insertPosition, 0, floatieSlideClone);
      thumbSlidesToAppend.splice(insertPosition, 0, floatieThumbSlideClone);

      console.log(`🏊‍♂️ Floatie slide inserted at position: ${insertPosition}`);
    }
  },

  filterSlides(selectedVariant) {
    const swiperEl = document.querySelector(".v2pdp-feature-swiper");
    const thumbSwiperEl = document.querySelector(".v2pdp-thumb-swiper");
    const swiper = swiperEl?.swiper;
    const thumbSwiper = thumbSwiperEl?.swiper;

    if (!swiper || !thumbSwiper) {
      console.error("Swiper instances not found");
      return;
    }

    let expectedAltText = this.mapVariantToAltText(
      selectedVariant.option1,
      selectedVariant.option2
    );

    if (!this.originalSlides) {
      this.originalSlides = Array.from(
        swiperEl.querySelectorAll(".swiper-slide")
      );
      this.originalThumbSlides = Array.from(
        thumbSwiperEl.querySelectorAll(".swiper-slide")
      );
    }

    // Filter slides based on the expected alt text
    const filteredSlides = this.originalSlides.filter((slide) => {
      const alt = slide.dataset.alt || slide.querySelector("img")?.getAttribute("alt")?.toLowerCase() || "";
      return alt.includes(expectedAltText.toLowerCase());
    });

    const filteredThumbSlides = this.originalThumbSlides.filter((slide) => {
      const alt = slide.dataset.alt || slide.querySelector("img")?.getAttribute("alt")?.toLowerCase() || "";
      return alt.includes(expectedAltText.toLowerCase());
    });
    // Separate different types of slides
    const shieldSlides = filteredSlides.filter((slide) =>
      slide.classList.contains("shield-slide")
    );
    const riserSlides = filteredSlides.filter((slide) =>
      slide.classList.contains("riser-slide")
    );

    const baseSlides = filteredSlides.filter((slide) => {
      const img = slide.querySelector("img");
      const src = img?.src.toLowerCase() || "";
      const isBaseSlide =
        !slide.classList.contains("shield-slide") &&
        !slide.classList.contains("riser-slide");

      // If riser is toggled, exclude front/side images from base slides
      if (this.riser && isBaseSlide) {
        return (
          !src.includes("visorsoff_front") && !src.includes("visorsoff_side")
        );
      }

      return isBaseSlide;
    });

    // Same for thumb slides
    const shieldThumbSlides = filteredThumbSlides.filter((slide) =>
      slide.classList.contains("shield-slide")
    );
    const riserThumbSlides = filteredThumbSlides.filter((slide) =>
      slide.classList.contains("riser-slide")
    );
    const baseThumbSlides = filteredThumbSlides.filter((slide) => {
      const img = slide.querySelector("img");
      const src = img?.src.toLowerCase() || "";
      const isBaseSlide =
        !slide.classList.contains("shield-slide") &&
        !slide.classList.contains("riser-slide");

      // If riser is toggled, exclude front/side images from base slides
      if (this.riser && isBaseSlide) {
        return (
          !src.includes("visorsoff_front") && !src.includes("visorsoff_side")
        );
      }

      return isBaseSlide;
    });

    let slidesToAppend = [];
    let thumbSlidesToAppend = [];

    // Determine which slides to show based on toggles
    if (this.shields && this.riser) {
      // If there are no shield slides, fall back to base slides
      if (shieldSlides.length === 0) {
        console.group("🔄 Slide Configuration:");
        console.log(
          "⚠️ No shield slides available, falling back to base slides"
        );
        console.log("📏 Riser slides active");
        console.groupEnd();
        slidesToAppend = [...riserSlides, ...baseSlides];
        thumbSlidesToAppend = [...riserThumbSlides, ...baseThumbSlides];
      } else {
        console.group("🔄 Slide Configuration:");
        console.log("🛡️ Shield slides active");
        console.log("📏 Riser slides active");
        console.log({
          shieldSlides: shieldSlides.length,
          riserSlides: riserSlides.length,
        });
        console.groupEnd();
        // shield slides have a count of 8, so the riser images were getting kicked to the end of the array
        const firstTwoShieldSlides = shieldSlides.slice(0, 2);
        const remainingShieldSlides = shieldSlides.slice(2);
        const firstTwoShieldThumbSlides = shieldThumbSlides.slice(0, 2);
        const remainingShieldThumbSlides = shieldThumbSlides.slice(2);

        slidesToAppend = [
          ...firstTwoShieldSlides,
          ...riserSlides,
          ...remainingShieldSlides,
        ];
        thumbSlidesToAppend = [
          ...firstTwoShieldThumbSlides,
          ...riserThumbSlides,
          ...remainingShieldThumbSlides,
        ];

        // Add floatie slide after shield slides and after riser slides
        this.insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, 5);
      }
    } else if (this.shields) {
      // If there are no shield slides, fall back to base slides
      if (shieldSlides.length === 0) {
        console.group("🔄 Slide Configuration:");
        console.log(
          "⚠️ No shield slides available, falling back to base slides"
        );
        console.groupEnd();
        slidesToAppend = [...baseSlides];
        thumbSlidesToAppend = [...baseThumbSlides];

        // Add floatie slide after first two base slides
        this.insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, 2);
      } else {
        console.group("🔄 Slide Configuration:");
        console.log("🛡️ Shield slides active");
        console.log(`Total shield slides: ${shieldSlides.length}`);
        console.groupEnd();
        slidesToAppend = [...shieldSlides];
        thumbSlidesToAppend = [...shieldThumbSlides];

        // Add floatie slide after first two shield slides
        this.insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, 2);
      }
    } else if (this.riser) {
      console.group("🔄 Slide Configuration:");
      console.log("📏 Riser slides active");
      console.log(`Total riser slides: ${riserSlides.length}`);
      console.groupEnd();
      slidesToAppend = [...riserSlides, ...baseSlides];
      thumbSlidesToAppend = [...riserThumbSlides, ...baseThumbSlides];

      // Add floatie slide after riser slides
      this.insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, 3);
    } else {
      console.group("🔄 Slide Configuration:");
      console.log("👓 Base slides only");
      console.log(`Total base slides: ${baseSlides.length}`);
      console.groupEnd();
      slidesToAppend = [...baseSlides];
      thumbSlidesToAppend = [...baseThumbSlides];

      // Add floatie slide after first two base slides
      this.insertFloatieSlide(slidesToAppend, thumbSlidesToAppend, 2);
    }

    // Remove display:none from active slides
    if (this.shields || this.riser) {
      slidesToAppend.forEach((slide) => {
        if (
          (this.shields && slide.classList.contains("shield-slide")) ||
          (this.riser && slide.classList.contains("riser-slide"))
        ) {
          slide.style.removeProperty("display");
        }
      });
      thumbSlidesToAppend.forEach((slide) => {
        if (
          (this.shields && slide.classList.contains("shield-slide")) ||
          (this.riser && slide.classList.contains("riser-slide"))
        ) {
          slide.style.removeProperty("display");
        }
      });
    }

    // Update swipers
    swiper.removeAllSlides();
    thumbSwiper.removeAllSlides();

    swiper.appendSlide(slidesToAppend);
    thumbSwiper.appendSlide(thumbSlidesToAppend);

    if (swiper.lazy && typeof swiper.lazy.load === "function") {
      swiper.lazy.load();
    }

    swiper.update();
    thumbSwiper.update();

    // Autoplay any video slides that were re-inserted into the DOM
    swiperEl.querySelectorAll(".swiper-slide video").forEach((video) => {
      video.play().catch(() => {});
    });

    swiper.slideTo(0, 0, false);
    thumbSwiper.slideTo(0, 0, false);

    // Debug console at the end of the function
    console.group("� Current State:");
    console.log("Toggle States:", {
      "🛡️ Shields": this.shields,
      "🛡️ Shield Toggle": this.isShieldToggleChecked,
      "📏 Riser": this.riser,
      "🏊‍♂️ Floatie": this.floatie,
    });
    console.groupEnd();

    // After slides are filtered, use debounced zoom initialization
    if (this.debouncedInitImageZoom) {
      this.debouncedInitImageZoom();
    }
  },

  listenToShields() {
    const checkbox = document.querySelector(
      'input[data-product-type="is_shield"]'
    );
    if (checkbox) {
      checkbox.addEventListener("change", () => {
        this.shields = checkbox.checked;
      });
    }
  },

  setupShieldToggle() {
    const shieldToggle = document.querySelector(
      'input[data-product-type="is_shield"]'
    );

    if (shieldToggle) {
      shieldToggle.addEventListener(
        "change",
        this.handleShieldToggle.bind(this)
      );
    }
  },

  setupFloatieToggle() {
    const floatieToggle = document.querySelector(
      'input[data-product-type="is_floatie"]'
    );

    if (floatieToggle) {
      floatieToggle.addEventListener(
        "change",
        this.handleFloatieToggle.bind(this)
      );
    }
  },

  handleShieldToggle(event) {
    this.shields = event.target.checked;
    this.isShieldToggleChecked = event.target.checked; // Track shield toggle state

    const currentVariantId = new URL(window.location.href).searchParams.get(
      "variant"
    );
    const currentVariant = this.productData.variants.find(
      (v) => v.id.toString() === currentVariantId
    );

    if (currentVariant) {
      this.filterSlides(currentVariant);
      if (this.shields) {
        this.scrollToFeaturedSwiper();
        this.updateUrlWithAddons("sideshields");
      } else {
        this.removeAddonFromUrl("sideshields");
      }
    }

    // Reinitialize zoom after shield toggle
    // this.reinitializeZoom();
  },

  handleFloatieToggle(event) {
    this.floatie = event.target.checked;
    const currentVariantId = new URL(window.location.href).searchParams.get(
      "variant"
    );
    const currentVariant = this.productData.variants.find(
      (v) => v.id.toString() === currentVariantId
    );

    if (currentVariant) {
      this.filterSlides(currentVariant);
      if (this.floatie) {
        const floatieUrl = this.getFloatieImageUrl();
        if (floatieUrl) {
          // Only proceed if we found a floatie image
          this.scrollToFeaturedSwiper();
          this.updateUrlWithAddons("floatie");
        } else {
          console.warn("No floatie image found in slider");
          event.target.checked = false;
          this.floatie = false;
        }
      } else {
        this.removeAddonFromUrl("floatie");
      }
    }

    // Reinitialize zoom after floatie toggle
    // this.reinitializeZoom();
  },

  setupRiserToggle() {
    const riserToggle = document.querySelector(
      'input[data-product-type="is_riser"]'
    );
    console.log("Riser toggle element:", riserToggle);
    if (riserToggle) {
      console.log("Adding riser toggle event listener");
      riserToggle.addEventListener("change", (event) => {
        console.log("Riser toggle changed:", event.target.checked);
        this.riser = event.target.checked;
        console.log("Riser state:", this.riser);

        // Handle price update for riser
        const addOnPrice = Number.parseFloat(
          riserToggle.dataset.toggleProductPrice
        .replace(/,/g, ''));
        if (this.riser) {
          this.selectedAddOns.set(riserToggle.value, addOnPrice);
        } else {
          this.selectedAddOns.delete(riserToggle.value);
        }

        // Update price display
        const price = document.getElementById("v2pdp-price");
        const basePrice = Number.parseFloat(price.dataset.basePrice.replace(/,/g, ''));
        this.debouncedUpdatePriceDisplay(basePrice);

        // Handle variant and URL updates
        const currentVariantId = new URL(window.location.href).searchParams.get(
          "variant"
        );
        const currentVariant = this.productData.variants.find(
          (v) => v.id.toString() === currentVariantId
        );

        if (currentVariant) {
          this.filterSlides(currentVariant);
          if (this.riser) {
            this.scrollToFeaturedSwiper();
            this.updateUrlWithAddons("riser");
          } else {
            this.removeAddonFromUrl("riser");
          }
        }
      });
    }
  },

  updateUrlWithAddons(addon) {
    const url = new URL(window.location.href);
    const currentAddons = url.searchParams.get("addons") || "";
    const addons = new Set(currentAddons.split(",").filter(Boolean));
    addons.add(addon);
    url.searchParams.set("addons", Array.from(addons).join(","));
    window.history.replaceState({}, "", url.toString());
  },

  removeAddonFromUrl(addon) {
    const url = new URL(window.location.href);
    const currentAddons = url.searchParams.get("addons") || "";
    const addons = new Set(currentAddons.split(",").filter(Boolean));
    addons.delete(addon);
    if (addons.size > 0) {
      url.searchParams.set("addons", Array.from(addons).join(","));
    } else {
      url.searchParams.delete("addons");
    }
    window.history.replaceState({}, "", url.toString());
  },

  checkUrlForAddons() {
    const url = new URL(window.location.href);
    const addons = url.searchParams.get("addons");
    if (addons) {
      const addonList = addons.split(",");

      // Handle shields first
      if (addonList.includes("sideshields")) {
        this.shields = true;
        const shieldToggle = document.querySelector(
          'input[data-product-type="is_shield"]'
        );
        if (shieldToggle) {
          shieldToggle.checked = true;
          shieldToggle.dispatchEvent(new Event("change"));
        }
      }

      // Then handle riser without forcing shields off
      if (addonList.includes("riser")) {
        this.riser = true;
        const riserToggle = document.querySelector(
          'input[data-product-type="is_riser"]'
        );
        if (riserToggle) {
          const shieldToggle = document.querySelector(
            'input[data-product-type="is_shield"]'
          );
          const originalShieldsState = this.shields; // Store shields state
          riserToggle.checked = true;
          riserToggle.dispatchEvent(new Event("change"));
          this.shields = originalShieldsState; // Restore shields state
          if (shieldToggle && originalShieldsState) {
            shieldToggle.checked = true; // Ensure shield toggle stays checked
          }
        }
      }

      // Finally handle floatie
      if (addonList.includes("floatie")) {
        this.floatie = true;
        const floatieToggle = document.querySelector(
          'input[data-product-type="is_floatie"]'
        );
        if (floatieToggle) {
          floatieToggle.checked = true;
          floatieToggle.dispatchEvent(new Event("change"));
        }
      }
    }
  },

  calculateTotalPrice(basePrice) {
    let totalPrice = parseInt(basePrice);
    console.log("totle price " + totalPrice);
    this.selectedAddOns.forEach((price) => {
      totalPrice += price;
    });
    return Math.round(totalPrice);
  },

  updatePriceDisplay(basePrice, compareAtPrice) {
    const price = document.getElementById("v2pdp-price");
    if (!price) return;

    // Get compare price from dataset if not provided and ensure it's a number
    compareAtPrice = compareAtPrice || Number(price.dataset.comparePrice) || 0;
    basePrice = Number(basePrice) || 0;

    // Calculate totals
    const totalPrice = this.calculateTotalPrice(basePrice);
    const totalCompareAtPrice = compareAtPrice
      ? this.calculateTotalPrice(compareAtPrice)
      : 0;

    // Format prices
    let totalPriceString = OmbrazUtils.formatMoneyInCents(
      totalPrice * 100
    ).toString();

    // Only show compare price if:
    // 1. Compare price exists (is greater than 0)
    // 2. Compare price is greater than the total price (there is an actual discount)
    // 3. Compare price is not equal to the total price
    if (
      totalCompareAtPrice > 0 &&
      totalCompareAtPrice > totalPrice &&
      totalCompareAtPrice !== totalPrice
    ) {
      const totalCompareAtString = OmbrazUtils.formatMoneyInCents(
        totalCompareAtPrice * 100
      ).toString();
      totalPriceString = `<span class="compare-at-price">${totalCompareAtString}</span> ${totalPriceString}`;
    }

    // Update DOM
    price.innerHTML = totalPriceString;
    price.setAttribute("aria-live", "polite");
  },

  getFloatieImageUrl() {
    // Get all slides from the original slides collection
    if (!this.originalSlides) return null;

    const floatieSlide = this.originalSlides.find((slide) => {
      const img = slide.querySelector("img");
      return img?.alt.toLowerCase().includes("floatie");
    });

    if (floatieSlide) {
      const img = floatieSlide.querySelector("img");
      return img?.src || null;
    }

    return null;
  },

  getRiserImageUrl() {
    // Get all slides from the original slides collection
    if (!this.originalSlides) return null;

    const riserSlide = this.originalSlides.find((slide) => {
      const img = slide.querySelector("img");
      return img?.alt.toLowerCase().includes("riser");
    });

    if (riserSlide) {
      const img = riserSlide.querySelector("img");
      return img?.src || null;
    }

    return null;
  },

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  scrollToFeaturedSwiper() {
    const featuredSwiper = document.querySelector(".v2pdp-feature-swiper");
    if (featuredSwiper && window.innerWidth <= 1024) {
      featuredSwiper.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  },

  /**
   * Cleans up lens variant options to show only relevant choices based on product type.
   * - For Polarized: shows only Polarized options
   * - For Non-Polarized: shows only Non-Polarized options
   * - For Blue-Blocking: shows only Blue-Blocking options
   * Works with both cleaned and uncleaned variant structures in Shopify backend.
   */
  cleanupVariantOptions() {
    // Get the first selected lens option to determine product type
    const selectedOption = document.querySelector(
      'input[name="Lens Options"]:checked, input[name="Lens Color"]:checked'
    );
    if (!selectedOption) return;

    const selectedValue = selectedOption.value.toLowerCase();
    // console.log("Selected value:", selectedValue);

    // Determine what type of product this is
    const isPolarized =
      selectedValue.includes("polarized") &&
      !selectedValue.includes("non-polarized");
    const isNonPolarized = selectedValue.includes("non-polarized");
    const isBlueBlocking = selectedValue.includes("blue-blocking");

    // Get only the lens options fieldset (second fieldset)
    const lensFieldset = document.querySelector(
      ".ombraz-v2pdp__product-options-wrapper fieldset:nth-child(2)"
    );
    if (!lensFieldset) return;

    // Get all lens option labels within the lens fieldset only
    const lensOptions = lensFieldset.querySelectorAll(".color-option");

    // Remove unwanted options
    lensOptions.forEach((option) => {
      const input = option.querySelector("input");
      if (!input) return;

      const value = input.value.toLowerCase();
      // console.log("Checking lens option:", value);

      // Skip RX option from cleanup
      if (input.hasAttribute("data-rx-option")) {
        console.log("Skipping RX option:", input);
        return;
      }

      if (
        isPolarized &&
        (value.includes("non-polarized") || value.includes("blue-blocking"))
      ) {
        option.remove();
      } else if (isNonPolarized && !value.includes("non-polarized")) {
        option.remove();
      } else if (isBlueBlocking && !value.includes("blue-blocking")) {
        option.remove();
      }
    });
  },

  // Add new method to reinitialize zoom
  /*  reinitializeZoom() {
    if (typeof handleImageZoom === "function") {
      handleImageZoom(".v2pdp-feature-swiper");
    }
  }, */

  // Helper function to show unavailable addons modal
  showUnavailableAddonsModal(unavailableAddons) {
    // Remove existing modal if any
    const existingModal = document.querySelector(
      ".ombraz-v2pdp__modal-overlay"
    );
    if (existingModal) existingModal.remove();

    const modalHtml = `
      <div class="ombraz-v2pdp__modal-overlay" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-modal="true">
        <div class="ombraz-v2pdp__modal">
          <button class="ombraz-v2pdp__modal-close" aria-label="Close dialog">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="ombraz-v2pdp__modal-content" aria-live="polite">
            <div class="modal-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#FF4A4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 id="modal-title">Unavailable Items</h3>
            <div id="modal-description">
              <p class="modal-message" role="alert">The following items are currently out of stock:</p>
              <ul class="unavailable-items" role="list">
                ${unavailableAddons
                  .map(
                    (addon) => `
                  <li role="listitem">
                    <span class="item-name">${addon.replace(
                      /\+(\$\d+)/,
                      " +$1"
                    )}</span>
                  </li>
                `
                  )
                  .join("")}
              </ul>
              <p class="modal-suggestion">Please remove these items to proceed with your purchase.</p>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHtml);
    this.setupModalEventListeners();
  },

  handleRxOption() {
    const rxInput = document.querySelector("[data-rx-option]");
    const atcWrapper = document.querySelector(".ombraz-v2pdp__atc-wrapper");
    const rxWrapper = document.querySelector(".rx");

    if (!rxInput || !atcWrapper || !rxWrapper) return;

    // Check URL for rx parameter on load
    const url = new URL(window.location.href);
    const rxParam = url.searchParams.get("rx");

    // Check if rx=true in URL
    if (rxParam === "true") {
      rxInput.checked = true;
      atcWrapper.classList.add("hide-this");
      rxWrapper.classList.remove("hide-this");
    }

    rxInput.addEventListener("change", (event) => {
      const url = new URL(window.location.href);

      if (event.target.checked) {
        // Show RX content, hide ATC
        atcWrapper.classList.add("hide-this");
        rxWrapper.classList.remove("hide-this");
        url.searchParams.set("rx", "true");
      } else {
        // Hide RX content, show ATC
        atcWrapper.classList.remove("hide-this");
        rxWrapper.classList.add("hide-this");
        url.searchParams.delete("rx");
      }

      window.history.replaceState({}, "", url.toString());
    });

    // Listen to other lens option changes
    const otherLensOptions = document.querySelectorAll(
      'input[name="Lens Options"], input[name="Lens Color"]'
    );
    otherLensOptions.forEach((option) => {
      if (option !== rxInput) {
        option.addEventListener("change", () => {
          if (option.checked) {
            // Reset RX state when another lens option is selected
            rxInput.checked = false;
            atcWrapper.classList.remove("hide-this");
            rxWrapper.classList.add("hide-this");
            const url = new URL(window.location.href);
            url.searchParams.delete("rx");
            window.history.replaceState({}, "", url.toString());
          }
        });
      }
    });
  },
};

document.addEventListener("DOMContentLoaded", v2PdpJs.init.bind(v2PdpJs));
window.addEventListener("beforeunload", v2PdpJs.destroy.bind(v2PdpJs));
